import { highlights, featureCategories } from '@/mocks/home';

export function HighlightsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {highlights.map((item) => (
            <div key={item.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
                {item.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-400">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CategoriesSection() {
  return (
    <section className="w-full py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            六大核心功能
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            从极速浏览到隐私安全，91浏览器为您提供全方位的优质体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featureCategories.map((cat) => (
            <div
              key={cat.id}
              className="group p-6 md:p-7 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${cat.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}